import { Link } from 'react-router-dom'
import { t } from '../i18n/index.js'
import { relativeDayLabel } from '../lib/format.js'
import type { OverlayTask } from './shell.js'

export function TaskCard({
  task,
  today,
  showDate,
  compact,
}: {
  task: OverlayTask
  today: string
  showDate?: boolean
  /** Inside an address group the property line would just repeat the header. */
  compact?: boolean
}) {
  const status = task.status === 'done' ? 'done' : task.status === 'missed' ? 'missed' : 'open'
  const future = task.dueDate > today && task.status !== 'done'

  return (
    <Link to={`/app/aufgabe/${task.id}`} className={`wk-task ${status} ${future ? 'future' : ''}`}>
      <div className="title">{task.title}</div>
      <div className="place">
        {compact ? task.label : `${task.siteName}, ${task.label}`}
        {task.unitLabel ? `, ${task.unitLabel}` : ''}
      </div>
      <div className="meta">
        {showDate && (
          <span className={`badge ${task.status === 'missed' ? 'missed' : ''}`}>
            {relativeDayLabel(task.dueDate, today)}
          </span>
        )}
        {task.dueTime && <span>{t('card.until', { time: task.dueTime })}</span>}
        {task.teamName && task.status !== 'done' && <span className="badge team">{t('card.team', { name: task.teamName })}</span>}
        {task.status === 'done' && task.textOption && <span className="muted">{task.textOption}</span>}
        {task.status === 'done' && (
          <span className="badge done">{task.pendingUpload ? t('card.sending') : t('card.done')}</span>
        )}
        {task.status !== 'done' && task.photoRequirement !== 'none' && (
          <span className="muted">
            {task.photoRequirement === 'before_after' ? t('card.photo_both') : t('card.photo_after')}
          </span>
        )}
      </div>
    </Link>
  )
}

/** Placeholder while the first load runs, better than flashing "nothing planned". */
export function TaskSkeleton({ count = 2 }: { count?: number }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <div className="skeleton wk-skeleton" key={index} />
      ))}
    </div>
  )
}
